import styled from "styled-components";

export const NLSWrapper = styled.div`
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
`;
export const NCarouselWrapper = styled.div`
  /* max-width: 812px; */
  width: 90%;
  height: 192px;
  background: rgba(255, 255, 255, 0.28);
  position: absolute;
  bottom: 2%;
  left: 5%;
  border-radius: 24px;
  backdrop-filter: blur(36px);
  padding: 44px 81px 68px 81px;

  img {
    position: absolute;
    left: 20px;
    top: 18px;
  }
`;
